// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, func, number, string } from 'prop-types'
import { Field } from 'redux-form'
import { UpdatedAutoSuggest } from 'components/Form'
import { assembleQuery, fetchSitesByQuery } from 'helpers/api'
import CustomSuggestionRender from './CustomSuggestionRender'
import SuggestionDetails from './SuggestionDetails'
import SuggestionsWrapper from './SuggestionsWrapper'

class UpdatedSiteAutoSuggest extends React.Component {
  static propTypes = {
    className: string,
    defaultContactId: number,
    disabled: bool,
    handleSelection: func.isRequired,
    idRoot: string.isRequired,
    label: string,
    nameRoot: string.isRequired,
    placeholder: string,
    unitType: string.isRequired,
  }

  prepQuery = (siteName, defaultContactId) => {
    // NOTE  - pathStatus of 'Finalized' hard coded here. (pathStatusId of 2)
    // we only want to include sites which are finalized in the results here.
    // we don't want to look at non-finalized stuff
    const searchArray = [{
      field: 'pathStatus',
      operator: 'EQ',
      value: 'Finalized',
    }, {
      field: 'contactId',
      operator: 'EQ',
      value: defaultContactId,
    }, {
      field: 'siteName',
      operator: 'LIKE',
      value: siteName,
    }]

    return assembleQuery([{
      field: 'search',
      value: searchArray,
    }])
  }

  fetchSuggestions = value => {
    const {
      defaultContactId,
    } = this.props

    if (!defaultContactId) {
      return { entities: [] }
    }
    const query = this.prepQuery(value, defaultContactId)
    return fetchSitesByQuery(query)
  }

  SuggestionComponent = p => (
    <CustomSuggestionRender
      {...p}
      SuggestionDetails={SuggestionDetails}
      unitType={this.props.unitType} />
  )

  render () {
    const {
      className,
      disabled,
      handleSelection,
      idRoot,
      label,
      lookup,
      nameRoot,
      placeholder,
    } = this.props

    return (
      <Field
        className={className}
        component={UpdatedAutoSuggest}
        disabled={disabled}
        fetchSuggestions={this.fetchSuggestions}
        handleSelection={handleSelection}
        id={`${idRoot}-siteName`}
        label={label}
        lookup={lookup}
        name={`${nameRoot}siteName`}
        optionKey={`siteId`}
        placeholder={placeholder}
        sortKey={`siteName`}
        renderSuggestionsContainer={SuggestionsWrapper}
        SuggestionComponent={this.SuggestionComponent} />
    )
  }
}

export default UpdatedSiteAutoSuggest
